import React from "react";
import {
  Box,
} from "@mui/material";
import {
  GreenTime,
  Pace,
  Reps,
  DumbellBlue,
  MuscleRed,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import ImageWithFallback from "@components/ui/ImageFallback";
import ExerciseVideoDisplay from "@features/exercise/ExerciseVideoDisplay";

const WorkoutBreakdownTable = ({ breakdown }) => {
  const { t } = useTranslation();
  const workoutData = [
    { exercise: "Barbell Bench Press", sets: 4, reps: "10, 8, 8, 6" },
    { exercise: "Incline Bench Press", sets: 3, reps: "8" },
    { exercise: "Decline Bench Press", sets: 2, reps: "10, 10, 8" },
    { exercise: "One Arm Dumbbell Row", sets: 5, reps: "10" },
    { exercise: "Barbell Bench Press", sets: 4, reps: "12" },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        // mx: 'auto',
        // p: 2,
        // '@media (max-width: 768px)': {
        //   p: 1,
        // }
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(150deg, #0771EF 12.89%, #15AAFC 85.22%)",
          borderRadius: "16px",
          px: 3,
          pt: 1,
          pb: 3,
          boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
          "@media (max-width: 768px)": {
            p: 2,
          },
        }}
      >
        <h5 className="text-[18px] font-[Lato] font-[500] text-white mb-3">
          {t("exercisePlan.workoutBreakdown")}
        </h5>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {breakdown?.map((item) => {
            const exercise = item?.exercise;
            return (
              <div className="bg-white rounded-[16px] p-3 md:p-2 flex flex-col items-center gap-2 lg:gap-4">
                <ExerciseVideoDisplay
                  src={exercise?.thumbnailUrl}
                  exerciseVideoUrl={exercise?.videoUri}
                  exercisePlan={true}
                  className="w-full object-cover rounded-[13px]"
                />
                <div className="w-full p-0 py-1 flex-1">
                  <p className="text-[14px] font-[Lato] font-[600] mb-2">
                    {exercise?.name}
                  </p>
                  <div className="flex flex-col gap-2 ">
                    {item?.durationSeconds && (
                      <div className="text-[#4CA842]  text-[12px] bg-[#D7FFD2] rounded-full px-2 py-1 flex items-center gap-2 ">
                        <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                          <GreenTime />
                        </p>{" "}
                        {t(`exercisePlan.duration`)}: {item?.durationSeconds} {t(`exercisePlan.seconds`)}
                      </div>
                    )}

                    {item?.pace && (
                      <div className="text-[#E58B00]  text-[12px] bg-[#FBEFDB] rounded-full px-2 py-1 flex items-center gap-2 ">
                        <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                          <Pace />
                        </p>{" "}
                        {t(`exercisePlan.Pace`)}: {item?.pace}
                      </div>
                    )}
                    {item?.reps && (
                      <div className="text-[#E5C600]  text-[12px] bg-[#F9FBDB] rounded-full px-2 py-1 flex items-center gap-2 ">
                        <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                          <Reps />
                        </p>{" "}
                        {t(`exercisePlan.Reps`)}: {item?.reps}
                      </div>
                    )}
                    {exercise.equipment?.length > 0 && (
                      <div className="text-[#00B7FE] text-[12px] bg-[#D2FCFF] rounded-full px-2 py-1 flex items-center gap-2 ">
                        <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                          <DumbellBlue />
                        </p>
                        {t(`exercisePlan.Equipment`)}:{" "}
                        {exercise.equipment.join(", ")}
                      </div>
                    )}

                    {exercise.equipment?.length > 0 && (
                      <div className="text-[#E50067] text-[12px] bg-[#FBDBEB] rounded-full px-2 py-1 flex items-center gap-2">
                        <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                          <MuscleRed />
                        </p>
                        {t(`exercisePlan.Muscle`)}:{" "}
                        {exercise.muscleGroups.join(", ")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Box>
    </Box>
  );
};

export default WorkoutBreakdownTable;
